<template> 
        <div class="container" id="prdListCntn">

            <div class="card p-4">
                <div class="container-fluid vendorDetailsWrapper mb-3">
                    <div class="row align-items-center">
                        <div class="col-md">
                            <div class="row align-items-center">
                                <div class="col-auto" v-if="showroomId && !showroomId.custom_addon">
                                    <div>
                                        <img :src="set_image(business_logo)" class="img-fluid vendorLogo" alt=""/>
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <div>
                                        <h3 class="vendorLogoName mb-1">{{ showroom_name }}</h3>
                                        <div class="d-flex flex-wrap textGreen">
                                            <div class="starsWrapper pe-3 font-16">
                                                <i aria-hidden="true" class="fa fa-star"></i>
                                                <i aria-hidden="true" class="fa fa-star"></i>
                                                <i aria-hidden="true" class="fa fa-star"></i>
                                                <i aria-hidden="true" class="fa fa-star"></i>
                                                <i aria-hidden="true" class="fa fa-star"></i>
                                            </div>
                                            <div class="fw-medium">5.0</div>
                                        </div>
                                        <div class="d-flex font-16">
                                            <a :href="'tel:'+phone_no" class="phoneLink">
                                                <span class="me-2"><i aria-hidden="true" class="fa fa-phone"></i></span>
                                                <span class="fw-medium">{{ phone_no|phone }}</span>
                                            </a>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            
                        </div>

                        <div class="col-md">
                            <ul class="list-unstyled ps-0 d-flex flex-wrap mb-0 justify-content-md-end mt-3 mt-md-0">
                                <li>
                                    <button class="actionBtn mb-2 mb-md-0" @click="$root.$emit('toogle_showroom', isVisible)">About Us</button>
                                </li>
                                <li v-if="web_site">
                                    <button class="actionBtn mb-2 mb-md-0" @click="redirect_site(web_site)">Homepage</button>
                                </li>
                                <!-- <li>
                                    <button @click="$router.push('/register')" class="actionBtn me-0">Sign up for FREE</button>
                                </li> -->
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="card-top container-fluid">
                    <div class="row mb-3 align-items-center">
                        <!-- <Breadcrumb></Breadcrumb> --> 

                    <div class="col-md-6">
                        <nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);"
                            aria-label="breadcrumb">
                            <ol class="breadcrumb mb-0">
                            <li class="breadcrumb-item">
                            <router-link to="/">All Products</router-link>

                            </li>
                            <li class="breadcrumb-item" aria-current="page" v-for="(item, x) in breadcumArr"
                            :key="'br' + x" :class="{active:breadcumArr.length==(x+1)}">
                            <span v-if="breadcumArr.length==(x+1)">{{ item.name }}</span>
                            <router-link :to="'/category/' + item.slug_url
                                " v-else>{{ item.name }}</router-link>
                            
                            </li>  
                            </ol>

                            </nav>
                    </div>

                    <div class="col-md-6">
                        
                    </div>

                    <!-- <div class="shoroomTogglerWrapper mt-2 mt-md-0">
                        
                        <button type="button" @click="$root.$emit('toogle_showroom', isVisible)"><img :src="business_logo" alt="" style="height: auto;width: 50px;" v-if="business_logo"> About {{showroom_name}}</button>
                    </div> -->

                    </div>

                    <!-- <div class="row d-sm-none">
                        <div class="col">
                            <button class="btn btn-primary p-2 font-15" @click="searchToggle()"><i aria-hidden="true" class="fa fa-search"></i></button>
                        </div>
                        
                        <div class="col text-end">
                            <button class="btn btn-primary p-2 font-12" @click="searchSearchBy()"><i aria-hidden="true" class="fa fa-sliders"></i> &nbsp; Shop By</button>
                        </div>
                    </div> -->
                
                    <div class="product-main-title mb-3 d-none d-md-block">
                        <h2 class="mb-3 mb-md-0 d-none d-sm-block">{{ categoryName }}
<!--                            <span class="font-18 font-400">{{ total }}-->
<!--								Products</span>-->
                        </h2>


                        

                        <div :class=" showSearch ? '' : 'd-none'" class="product-sort d-md-flex">
                            <div class="sort-by">
                                <select v-model="sortingValue"  @change="sorting()" class="form-select form-select-lg">
                                    <option value="">Sort By</option>
                                    <option value="price desc">Sort By: Price (High to Low)</option>
                                    <option value="price asc">Sort By: Price (Low to High)</option>

                                </select>
                            </div>
<!--                            <div class="rightSearch">-->
<!--                                <form @submit.prevent="searchFilter">-->
<!--                                    <div class="searckGroup">-->
<!--                                        <button type="submit"><i class="fa fa-search"></i></button>-->
<!--                                        <span><input type="text" placeholder="Search product…" name="search" v-model="search"></span>-->
<!--                                    </div>-->
<!--                                </form>-->
<!--                            </div>-->

                            <div class="pro-search">
                                <form @submit.prevent="searchFilter">
                                    <div class="search-input">
                                        <input class="form-control" type="text" placeholder="Search Product by Name/ SKU" v-model="search">
                                        <button class="btn btn-primary"><i class="fa fa-search"
                                                                           aria-hidden="true"></i></button>
                                    </div>
                                </form>
                            </div>
                            <!-- <div class="view ms-3">
								<button type="button" class="btn btn-outline-dark">Grid View</button>
							</div> -->
                        </div>
                    </div>

                    
                    

                    <div class="d-flex align-items-center justify-content-end mb-3">
                       <!--  <router-link to="/visualize" class="btn btn-primary">Visualizer</router-link> -->
                    </div>
                </div>

                <div class="product-main-title mb-3 d-md-none">
                    <div class="product-sort mt-0">
                        <div class="pro-search">
                            <form @submit.prevent="searchFilter">
                                <div class="search-input">
                                    <input class="form-control" type="text" placeholder="Search Product by Name/ SKU" v-model="search">
                                    <button class="btn btn-primary"><i class="fa fa-search" aria-hidden="true"></i></button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>


                <div class="d-flex align-items-center mb-3 d-md-none">
                    <div class="mo-filter-btn">
                        <button
                        class="btn btn-secondary px-3 py-2 text-start d-inline-block d-lg-none font-weight-bold font-14 text-uppercase btn-toggle-filter d-flex">
                            <svg className="me-2" width="20" height="18" viewBox="0 0 20 18" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.7778 1H1L8.11111 9.40889V15.2222L11.6667 17V9.40889L18.7778 1Z"
                                        stroke="#313131" strokeWidth="1.5" strokeLinecap="round"
                                        strokeLinejoin="round" />
                            </svg>
                            <span class="ps-1">Filter</span>
                        </button>

                    </div>
                    


                    <div class="product-sort mx-1">
                        <div class="sort-by">
                            <select v-model="sortingValue"  @change="sorting()" class="form-select form-select-md" style="font-size: 14px !important">
                                <option value="">Sort By</option>
                                <option value="price desc">Sort By: Price (High to Low)</option>
                                <option value="price asc">Sort By: Price (Low to High)</option>

                            </select>
                        </div>
                    </div>

                    <button class="btn btn-primary p-2 font-14 d-flex" @click="searchSearchBy()"><i aria-hidden="true" class="fa fa-sliders"></i> &nbsp; <span class="ps-1">Shop&nbsp;By</span></button>
                </div>

                

                <div class="row d-sm-table-row " :class="showShopBy ? '': 'd-none'">
                    <div class="col-12">                        
                        <div class="product-list-tab">
                            <ul class="nav nav-tabs" id="pills-tab" role="tablist">
                                  <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="pro-4-tab" data-bs-toggle="pill"
                                            data-bs-target="#pro-cat-tab" type="button" role="tab"
                                            aria-controls="pro-cat-tab"
                                            aria-selected="false">Shop By {{ fcat_name }}
                                    </button>
                                </li>  
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link " id="pro-3-tab" data-bs-toggle="pill"
                                            data-bs-target="#pro-tab-3" type="button" role="tab"
                                            aria-controls="pro-tab-3"
                                            aria-selected="false">Shop By Top Brands
                                    </button>
                                </li>
                                
                            </ul>
                            <div class="tab-content border border-top-0 pt-3" id="pills-tabContent">
                                
                                <div class="tab-pane fade" id="pro-tab-3" role="tabpanel" aria-labelledby="pro-3-tab"
                                     tabindex="0">
                                    <div class="tab-product-list">

                                        <a href="javascript:void(0);" @click="vendor=brand.id; getProduct();" class="tab-product-card" v-for="(brand,x) in vendors" :key="'br'+x">
                                            <div class="product-img">
                                                <img :src="set_image(brand.shop_profile.business_logo)" alt="">
                                            </div>
                                            <h6 class="tab-product-title">{{ brand.shop_profile? brand.shop_profile.company_name:brand.company_name }}</h6>
                                        </a>

                                        
                                    </div>
                                </div>
                               <div class="tab-pane fade  show active" id="pro-cat-tab" role="tabpanel" aria-labelledby="pro-4-tab"
                                     tabindex="1">
                                    <div class="tab-product-list">
                                        <a href="javascript:void(0);" @click="filter_cat('/category/' + cat.slug_url+'/product',cat)" class="tab-product-card" v-for="(cat,x) in filter_cats" :key="'ct'+x">
                                        
                                            <div class="product-img">
                                                <img :src="set_image(cat.photo)" :alt="cat.name" />
                                            </div>
                                            <h6 class="tab-product-title">{{ cat.name }}</h6>
                                        </a>

                                        
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Product Filter Top Start -->

                <!-- <div class="mo-filter-btn">
                    <button
                        class="btn btn-secondary px-4 text-start d-inline-block d-lg-none ms-2 font-weight-bold text-uppercase btn-toggle-filter">
                        <svg className="me-2" width="20" height="18" viewBox="0 0 20 18" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.7778 1H1L8.11111 9.40889V15.2222L11.6667 17V9.40889L18.7778 1Z"
                                    stroke="#313131" strokeWidth="1.5" strokeLinecap="round"
                                    strokeLinejoin="round" />
                        </svg>
                        Filter
                    </button>
                </div> -->
                <div class="product-filter-top">
                    <button type="button" class="btn btn-outline-primary btn-clear" @click.prevent="resetFilterHandler">
                        x Clear All
                    </button>
                    <div class="filter-list">

                        <div class="filter-item" v-for="(filter,key) in filterInputs" :key="key">
                            <label class="filter-name" v-if="filter.length">{{ getFilterName(key) }}</label>
                            <div class="filter-close" v-if="filter.length" v-for="(value,index) in filter" :key="index">
                                <span class="filter-status" style="text-transform: uppercase !important;">{{ value }}</span>
                                <!--                                <button type="button" class="btn-close" aria-label="Close" @click="removeItem(filterInputs,index)"></button>-->
                            </div>
                        </div>
                    </div>
                </div>
                <!--                <div v-for="dd in sp" :key="dd">-->
                <!--                    {{dd.name}}-->

                <!--                </div>-->

                <!-- Product Filter Top End -->

                <div class="row">
                    <div class="col-md-12 col-lg-3 col-xl-3">
                        <!-- Cat Sidebar Start -->
                        <div class="cat-filter mb-3 mb-lg-0 vld-parent" ref="filter_ref">
                            <div class="accordion filter-accordion" id="accordionPanelsStayOpenExample">
                                <div class="filter-header">
                                    <button type="button" class="btn-close" aria-label="Close"></button>
                                </div>
                                <div class="accordion-item" v-if="filter_inputs && input.section_options && input.section_options.length>0" v-for="(input,index)  in filter_inputs"
                                     :key="index">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                :data-bs-target="'#'+input.id" aria-expanded="true"
                                                :aria-controls="input.id">
                                            {{ input.name }}
                                        </button>
                                    </h2>
                                    <div :id="input.id" class="accordion-collapse collapse">
                                        <div class="accordion-body">
                                            <div class="form-group mb-0">
                                                <div class="form-check custom-check"
                                                     v-for="(value,x) in input.section_options" :key="x">
                                                    <input class="form-check-input" type="checkbox"
                                                           :value="value.op_value"
                                                           name="filter_inputs[]"
                                                           :id="'fltr'+x+'-'+index" v-model="filterInputs['fltr-'+input.id]"
                                                           :checked="value.input_id===selecFitler"
                                                           @change.prevent="getFilterData(input.name+'-'+value.op_value)">
                                                    <label class="form-check-label" :for="'fltr'+x+'-'+index"
                                                           v-model="form.color">
                                                        {{ value.op_value }} ({{ value.total_products_count }})

                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <!-- Cat Sidebar End -->
                    </div>
                    <div class="col-md-12 col-lg-9 col-xl-9">
                        <div class="product-list product-list-desc mb-5">

                            <ItemList :product="product" :beforesearch="beforesearch"></ItemList>
                            <!-- Pagination Start -->
<!--                            <NewPagination-->
<!--                                :prePage="prePage"-->
<!--                                :total="total"-->
<!--                                :prevUrl="prevUrl"-->
<!--                                :paginationLink="paginationLink"-->
<!--                                :nextUrl="nextUrl"-->
<!--                                :current_page="current_page"-->
<!--                                @fatchData="fatchData">-->

<!--                            </NewPagination>-->

                            <NewPagination

                                @fatchData="fatchData">

                            </NewPagination>
                            <!-- Pagination End -->
                        </div>
                    </div>
                </div>

                <!-- Also Viewed Section Start -->
                <CustomerViewed :CustomerView="CustomerView"></CustomerViewed>
                <!-- Also Viewed Section End -->
            </div>

            <!-- Recently Viewed  Section Start -->
            <RecentlyViewed :recentlyViewed="RecentlyViewed"></RecentlyViewed>
            <!-- Recently Viewed  Section End -->
        </div> 
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import axios from "axios";
import Loading from "../../components/Loading"; 


 
const ItemList = () => ({
    component: import('../../components/ItemList.vue'),
    loading: Loading,
})
const NewPagination = () => ({
    component: import('../../Elements/NewPagination.vue'),
    loading: Loading,
});

const CustomerViewed = () => ({
    component: import('../../components/CustomerViewed.vue'),
    loading: Loading,
});

const RecentlyViewed = () => ({
    component: import('../../components/RecentlyViewed.vue'),
    loading: Loading,
});


const SideFilter = () => ({
    component: import('../../components/SideFilter.vue'),
    loading: Loading,
});


export default {
    props: ['categories',"isVisible","showroom_name","business_logo","phone_no","web_site"],
    metaInfo() {
    return {
        title: this.meta.page_title +' | ' + appname,
        meta: [
        {
            vmid: 'description',
            name: 'description',
            content: this.meta.description
        },
        {
            vmid: 'canonical',
            rel: 'canonical',
            href: this.meta.currentUrl
        },
        {
            vmid: 'og:title',
            property: 'og:title',
            content: this.meta.page_title +' | ' + appname
        },
        {
            vmid: 'og:description',
            property: 'og:description',
            content: this.meta.description
        },
        {
            vmid: 'twitter:title',
            property: 'twitter:title',
            content: this.meta.page_title +' | ' + appname
        },
        {
            vmid: 'twitter:description',
            property: 'twitter:description',
            content: this.meta.description
        },
        {
            vmid: 'twitter:image',
            property: 'twitter:image',
            content: this.meta.image
        },
        {
            vmid: 'keywords',
            property: 'keywords',
            content: this.meta.keywords
        },
        ]
    };
    },
    components: {
        SideFilter, 
        ItemList,
        NewPagination, 
        CustomerViewed,
        RecentlyViewed
    },
    data() {
        return {
            meta:{
                page_title:'Products',
                description:'Product ' + appname,
                keywords:'Product ' + appname,
                currentUrl: window.location.origin + this.$route.fullPath,
                image:''
            },
            filter_cats:'',
            fcat_name:'',
            breadcumArr:'',
            shop_categories:'',
            beforesearch:1,
            vendor:'',
            vendors:'',
            showroom: [],
            paginationLink: [],
            nextUrl: '',
            prevUrl: '',
            total: '',
            current_page: '',
            search: '',
            prePage: '',
            product: [],
            categoryId: '',
            categoryName: '',
            filterInput: {},
            filter_inputs: '',
            filterInputs: {},
            selected_filter: [],
            sp: [],
            form: {
                filterInputs: {},
                selected_filter: {},

            },
            selecFitler: '',
            sortingValue:'',
            showSearch: false,
            showShopBy: false
        }
    },
    beforeCreate(){

        console.log();

    },

    watch: {
        'form.category'(n) {
            this.form.filterInputs = {}
            if (this.form.category) {
                //this.filter_box();
            }
        },
        async filter_inputs(n) {
            for (let ic = 0; ic < n.length; ic++) {
                let fname = 'fltr-' + n[ic].id;
                var ex = this.filterInputs['fltr-' + n[ic].id]
                if (ex) {
                    this.$set(this.filterInputs, fname, ex)
                } else {
                    this.$set(this.filterInputs, fname, [])
                }

            }
            this.form.filterInputs = this.filterInputs
        },
        filterInputs: {
            handler: function (newValue) {
                this.form.filterInputs = this.filterInput
            },
            deep: true
        },

        categories: {
            handler: function (newValue) {
                this.shop_categories = newValue
                this.gen_breadcum()
            },
            deep: true, 
        },


    },

    computed: {
        ...mapGetters({
            showroomId: 'Common/MyItem',
            productCategory: 'Common/ProductCategory',
            ProductList: 'Common/ProductList',
            CustomerView: 'Common/CustomerViewed',
            RecentlyViewed: 'Common/RecentlyViewed',
            Pagination:'Common/Pagination',
            Breadcrumb:'Common/Breadcrumb',
        })
    },

    methods: {
        ...mapActions('Common', ['updateNewLayout', 'updateCategory', 'updateBreadcrumb', 'setCustomerView', 'setRecentlyViewed','setPagination',"updateProductCategory"]),
        filter_cat(url,cat){ 
            this.updateProductCategory({
                category_id:cat.id,
                category_name:cat.name,
            })
            this.$router.push(url).catch(() => {})
        },
        gen_breadcum() {
            let res=[];
            if (this.shop_categories && this.shop_categories.length > 0) {
                let result = this.shop_categories.filter((word) => word.slug_url === this.$route.params.category);
                if(result){
                    this.updateProductCategory({
                        category_id:result[0].id,
                        category_name:result[0].name,
                    })
                }
                res = [];
                let ids = result[0].parent_ids.split(',');

                let pid = result[0].parent_id ? result[0].parent_id : result[0].id
                this.filter_cats = this.shop_categories.filter(item => item.parent_id === pid);
                if (result[0].parent_id) {
                    let k = this.shop_categories.filter(item => item.id === result[0].parent_id);
                    this.fcat_name = k[0].shopby_name ? k[0].shopby_name:k[0].name
                } else {

                    this.fcat_name = result[0].shopby_name ? result[0].shopby_name : result[0].name
                }


                for (const i of ids) {
                    let b = this.shop_categories.filter((word) => word.id == i);
                    res.push(b[0])
                }
            }

            this.breadcumArr = res
            if(res && res.length>0){
                let lastArrayElement = res[res.length - 1];
                if(lastArrayElement){
                    this.meta.page_title = lastArrayElement.name || 'Products List';
                    this.meta.currentUrl = window.location.href
                    this.meta.description = lastArrayElement.name || 'Products List';
                    this.meta.keywords = lastArrayElement.name || 'Products List';
                    this.meta.image = this.set_image(lastArrayElement.photo)|| '';
                }
            }

        },
        get_brands(){
            axios.post('api/visualization/get_brands', {
                    category_slug:this.$route.params.category,
                    category: this.productCategory.category_id,
                    showroom: this.showroomId.showroom,
                    vsd_id: shop_id,
                    filterInputs: this.filterInputs,
                    search:this.form.search,
                    sort_by:this.sortingValue
                }).then((res) => {
                    this.vendors=res.data.data;
                });
        },


        sorting(){
            this.getProduct('/api/visualization/products')
        },

        searchFilter(){
            this.form.search = this.search

            this.getProduct('/api/visualization/products')
        },


        async filter_products(url = '/api/visualization/products') {

            if (this.form.category) {
                this.filter_box();
            }
            this.form.search = this.search
            var retrievedItem = this.get_loc_stroge('my_item');
            if (retrievedItem) {
                this.form.showroom = retrievedItem.showroom;
                this.form.floorplan = retrievedItem.floorplan
                this.form.floorTemplate = retrievedItem.floorTemplate;
                this.form.is_3d = retrievedItem.is_3d;
            }
            if ((this.form.f_item == '' || this.form.f_item == null) && this.form.is_3d) {
                this.products = ''
                return false;
            }

            let subform = new Form(this.form)
            subform.category = this.form.category ? this.form.category.id : ''
            let product_list = this.$loading.show({
                // container: this.$refs.visual_main_ref,
            });
            subform.post(url)
                .then((response) => {
                    this.products = ''
                    if (response.data.success == true) {
                        subform.reset();
                        this.products = response.data.data;
                    }
                    product_list.hide()
                })
                .catch((err) => {
                    product_list.hide()
                })
        },

        resetFilterHandler() {
            this.vendor=''
            this.filterInputs = {};
            this.form.category = '';
            this.form.favorite = []
            this.search = '';
            this.brands = []
            this.form.size = {
                type: 'in'
            };
            // for (let ic = 0; ic < this.product_attributes.length; ic++) {
            //     let elm = this.product_attributes[ic]
            //     this.form.attributes[ic] = []
            // }
            if(this.filter_inputs){
            for (let ic = 0; ic < this.filter_inputs.length; ic++) {
                let fname = 'fltr-' + this.filter_inputs[ic].id;
                this.$set(this.filterInputs, fname, [])
            }
        }
            this.form.filterInputs = this.filterInputs
            this.filter_tag = false;
            this.getProduct('/api/visualization/products');


            let form = {
            search: "",
            category_slug:this.$route.params.category,
            category: this.productCategory.category_id,
            showroom: this.showroomId.showroom,
            vsd_id: shop_id,
            f_item: '',
            floorplan: '',
            floorTemplate: '',
            is_3d: false,

        };
            let filterLoader = this.$loading.show({
                        container: this.$refs.filter_ref,
                });
            axios.post('/api/visualization/filter_box', form).then((res) => {
            this.filter_inputs = res.data.data
            res.data.data.forEach((currentElement) => {
                this.sp.push({
                    serach: 'fltr-' + currentElement.id,
                    name: currentElement.name
                }) 
            }) 
            filterLoader.hide();
        }) 
        },
        getProduct(url='/api/visualization/products') {


            let product_list = this.$loading.show({
                // container: this.$refs.visual_main_ref,
            });
            axios.post(url, {
                category_slug:this.$route.params.category,
                category: this.productCategory.category_id,
                showroom: this.showroomId.showroom,
                vsd_id: shop_id,
                filterInputs: this.filterInputs,
                search:this.form.search,
                sort_by:this.sortingValue,
                brands:this.vendor
            }).then((res) => {
               this.beforesearch=0;
                this.product = res.data.data.data
                this.paginationLink = res.data.data.links
                this.nextUrl = res.data.data.next_page_url
                this.prevUrl = res.data.data.prev_page_url
                this.total = res.data.data.total
                this.categoryName = this.productCategory.category_name
                this.current_page = res.data.data.current_page
                this.prePage = res.data.data.per_page
                this.setPagination({
                    paginationLink:res.data.data.links,
                    nextUrl:res.data.data.next_page_url,
                    prevUrl :res.data.data.prev_page_url,
                    total :res.data.data.total,
                    current_page :this.Pagination.current_page!==''?this.Pagination.current_page:res.data.data.current_page,
                    prePage :res.data.data.per_page
                })
                this.contentScroll('prdListCntn',-200);
                product_list.hide();
            }).catch((error) => {
            })
        },
        getFilterData() {            
            this.getProduct('/api/visualization/products');

            let form = {
                filterInputs: this.filterInputs,
                search: this.form.search,
                category_slug:this.$route.params.category,
                category: this.productCategory.category_id,
                showroom: this.showroomId.showroom,
                vsd_id: shop_id,
                f_item: '',
                floorplan: '',
                floorTemplate: '',
                is_3d: false,

            };

            let filterLoader = this.$loading.show({
                  container: this.$refs.filter_ref,
            });

            axios.post('/api/visualization/filter_box', form).then((res) => {
            this.filter_inputs = res.data.data
            res.data.data.forEach((currentElement) => {
                this.sp.push({
                    serach: 'fltr-' + currentElement.id,
                    name: currentElement.name
                }) 
            }) 
            filterLoader.hide()
        }) 

        },
        getFilterName(key) {
            var item = this.sp.filter((word) => word.serach === key);
            return item[0].name
        },
        fatchData(page, url) {
            var pageUrl = ''
            if (url !== '') {
                pageUrl = url;
            } else {
                pageUrl = "/api/visualization/products?page=" + page
            }

            this.setPagination({
                current_page :page
            })



            this.getProduct(pageUrl)
        },

        checked(value) {
            this.getProduct('/api/visualization/products')
        },

        searchToggle(){
            this.showSearch = !this.showSearch
        },
        searchSearchBy(){
            this.showShopBy = !this.showShopBy
        }

    },

    created() {
       

    },
    mounted(){
        this.gen_breadcum()
        this.contentScroll('prdListCntn',-200);
    function toggleFilterBar() {
        $(".cat-filter").toggleClass("open");
        $("body").toggleClass("open");
    }
    $(".mo-filter-btn .btn").click(function () {
        toggleFilterBar();
    });

    $(".filter-header .btn-close").click(function () {
        toggleFilterBar();
    });
},
 

    beforeMount() { 
        this.updateNewLayout('Yes')
        this.$root.$on('filter_products', (arr) => {
            if (arr != this.form.f_item) {
                this.form = {
                    search: '',
                    category: '',
                    favorite: [],
                    f_item: arr,
                    brands: [],
                    size: {
                        type: 'in'
                    },
                    attributes: [],
                    filterInputs: {}
                }
                this.products = ''
                this.form.f_item = arr;
            }
        })


        let data = {
            category_slug:this.$route.params.category,
            category: this.productCategory.category_id,
            showroom: this.showroomId.showroom,
            vsd_id: shop_id,
        }
        this.setCustomerView(data)
        this.setRecentlyViewed(data)

        // this.updateBreadcrumb({
        //     'parent': this.productCategory.category_name,
        //     'child': '',
        //     'product': '',
        // })

        this.getProfile().then((res) => {
            this.showroom = res.data.data
        }).catch((error) => {
        })

        let page=this.Pagination.current_page!==''?this.Pagination.current_page:1

        this.getProduct('/api/visualization/products?page='+page)
        this.get_brands();


        let form = {
            search: "",
            category_slug:this.$route.params.category,
            category: this.productCategory.category_id,
            showroom: this.showroomId.showroom,
            vsd_id: shop_id,
            f_item: '',
            floorplan: '',
            floorTemplate: '',
            is_3d: false,

        };

        axios.post('/api/visualization/filter_box', form).then((res) => {
            this.filter_inputs = res.data.data
            res.data.data.forEach((currentElement) => {
                this.sp.push({
                    serach: 'fltr-' + currentElement.id,
                    name: currentElement.name
                })

            })


        }).catch((error) => {
        })
        
    }
    
}


</script>
 